/**
 * Injects theme styles into the Shopify Forms shadow root on the heat press inquiry page.
 */
class HeatPressInquiryForm {
    static SELECTOR = '[data-forms-id="forms-root-1031220"]';
    static STYLE_ATTR = 'data-heat-press-form-styles';
    static TIMEOUT_MS = 15000;
  
    static FORM_STYLES = `
        #app-embed { width: 100%; }

        #app-embed ._container_3eyaa_70 { display: block !important; }

        #form-container-ref section[data-sizing="form-wrapper"] { max-width: 100% !important; margin: 0; }

        ._formFieldset_cit2d_82 shop-lead-capture:empty, ._formFieldset_cit2d_82 > div:has(> shop-lead-capture:empty),
        [novalidate] [role="alert"] { display: none !important; }

        div[class*="withError"] > input, [novalidate]:has(input~label) > div[class*="withError"] > input {
            border-bottom-color: var(--form-error-color) !important;
            box-shadow: none !important;
        }
    
        #form-container-ref form._formFieldset_cit2d_82 { 
            padding: 0 !important;
            display: grid !important;
            gap: 15px !important;
        }
    
        ._formFieldset_cit2d_82 > ._formFieldContainer_1mxsl_5:nth-last-of-type(2),
        ._formFieldset_cit2d_82 > ._formFieldContainer_1mxsl_5:nth-last-of-type(1),
        #form-container-ref form._formFieldset_cit2d_82 ._formSubmitButton_cit2d_96 { grid-column: 1 / -1 !important; }

        #form-container-ref form._formFieldset_cit2d_82 ._formPhoneInputContainer_piv1u_6 ._selectContainer_12thd_6 { height: 100% !important; }

        #form-container-ref form._formFieldset_cit2d_82 ._formPhoneInputContainer_piv1u_6 ._selectContainer_12thd_6 button { 
            padding: 10px !important;
            border: none !important;
            min-height: 100% !important;
            max-height: 100% !important;
        }

        #form-container-ref form._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 input:focus,
        #form-container-ref form._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5:has(label._inputFilled_1mxsl_74) input,
        #form-container-ref form._formFieldset_cit2d_82 ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 input,
        #form-container-ref form._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 textarea:focus { padding: 11px 15px !important; }

        #form-container-ref form._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 input + label._inputFilled_1mxsl_74,
        #form-container-ref form._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 input:focus + label,
        #form-container-ref form._formFieldset_cit2d_82 ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 input + label._inputFilled_1mxsl_74,
        #form-container-ref form._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 textarea + label._inputFilled_1mxsl_74,
        #form-container-ref form._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 textarea:focus + label { 
          opacity: 0 !important;
          transform: none !important;
          top: 0 !important;
          left: 0 !important;
          font-size: 16px !important;
          line-height: 1.219 !important;
          padding: 11px 15px !important;
        }
        
        #form-container-ref input, #form-container-ref textarea {
            box-shadow: none;
            height: 100%;
            font-size: 16px;
            line-height: 1.5;
            font-weight: 400;
            color: #74786C;
            padding: 11px 15px;
            border-radius: 2px;
            border: 1px solid #B9BBB5;
            background-color: transparent;
            font-family: mreavesxlmodotheavy !important;
            transition: all 0.3s ease-in-out !important;
        }
    
        #form-container-ref label._formInputFieldLabel_1mxsl_38 {
            font-size: 16px;
            line-height: 1.5;
            font-weight: 400;
            color: #74786C;
            transition: none !important;
            font-family: mreavesxlmodotheavy !important;
        }

        #app-embed #form-container-ref input:not(:focus) + label:not(._inputFilled_1mxsl_74) {
          padding: 9px 15px;
          top: 0 !important;
          left: 0 !important;
          transform: none !important;
        }
    
        #form-container-ref input:not(:focus) + label:not(._inputFilled_1mxsl_74) {
            top: 50% !important;
            left: 20px !important;
            transform: translateY(-50%) !important;
        }
    
        #form-container-ref input:focus, 
        #form-container-ref textarea:focus,
        #form-container-ref div._formFieldContainer_1mxsl_5:has(label._inputFilled_1mxsl_74) input { 
            padding-top: 22px !important; 
            padding-bottom: 6px !important; 
        }
    
        #form-container-ref input:focus + label,
        #form-container-ref textarea:focus ~ label,
        #form-container-ref input + label._inputFilled_1mxsl_74,
        #form-container-ref textarea ~ label._inputFilled_1mxsl_74 {
            top: 6px !important;
            left: 16px !important;
            line-height: 1 !important;
            font-size: 9px !important;
            transform: none !important;
        }
    
        #form-container-ref ._label_12thd_10 {
            line-height: 1;
            font-size: 16px;
            font-weight: 400;
            margin-bottom: 16px;
            font-family: mreavesxlmodotheavy !important;
        }
    
        button._selectToggle_12thd_25 {
            height: 100% !important;
            color: #000000 !important;
            line-height: 1 !important;
            font-size: 14px !important;
            font-weight: 400 !important;
            min-height: 50px !important;
            max-height: 50px !important;
            box-shadow: none !important;
            padding: 14px 16px !important;
            border-radius: 20px !important;
            border: 1px solid #000000 !important;
            font-family: mreavesxlmodotheavy !important;
        }
    
        ._selectContainer_12thd_6 ._selectToggle_12thd_25 ._arrowDownIcon_12thd_19:after {
            content: '';
            display: block;
            width: 14px;
            height: 7px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M0.75 0.75L4.63889 4.63889L8.52778 0.75' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            transition: transform 0.3s ease-in-out;
        }
    
        ._selectContainer_12thd_6 ._selectToggle_12thd_25 ._arrowDownIcon_12thd_19 svg { display: none !important; }
    
        ._selectContainer_12thd_6 ._selectToggle_12thd_25 ._dropdownContainer_12thd_63 ._optionList_12thd_86 ._optionListItem_12thd_102 {
            font-size: 16px !important;
            font-weight: 400 !important;
            color: #000000 !important;
            line-height: 1 !important;
            text-transform: capitalize !important;
            font-family: mreavesxlmodotheavy !important;
            transition: all 0.3s ease-in-out !important;
        }
    
        ._selectContainer_12thd_6 ._selectToggle_12thd_25 ._dropdownContainer_12thd_63 ._optionList_12thd_86 ._optionListItem_12thd_102:hover { outline: none !important; border-color: #F6F6F6 !important; background-color: #F6F6F6 !important; }
    
        #form-container-ref textarea { height: 140px !important; overflow: hidden !important; }
    
        #form-container-ref textarea ~ label { top: 15px !important; left: 20px !important; }
    
        #form-container-ref button._formSubmitButton_cit2d_96 {
            place-self: end;
            line-height: 1 !important;
            font-size: 16px !important;
            color: #171E0A !important;
            font-weight: 700 !important;
            padding: 12px 40px !important;
            border-radius: 2px !important;
            text-align: center !important;
            letter-spacing: 0.02em !important;
            text-transform: capitalize !important;
            background-color: #E5AD52 !important;
            border: 1px solid #E5AD52 !important;
            font-family: mreavesxlmodotheavy !important;
        }
    
        #form-container-ref button._formSubmitButton_cit2d_96:hover { border-color: #CB9339 !important; background-color: #CB9339 !important; }
    
        ._formFieldContainer_1mxsl_5:has(textarea)::before { display: none !important; }
    
        #app-embed ._inline_1q1d2_47 ._formBannerContainer_z5ku3_1 h2 { 
            font-size: 36px;
            color: #171E0A;
            font-weight: 400;
            line-height: 1.2;
            font-family: mreavesxlmodotheavy;
        }
    
        #app-embed ._inline_1q1d2_47 ._formBannerContainer_z5ku3_1 div p {
            font-size: 16px;
            font-weight: 400;
            line-height: 1.55;
            font-family: mreavesxlmodotheavy !important;
        }

        @media (min-width: 768px) {
            #form-container-ref form._formFieldset_cit2d_82 {
                gap: 20px 30px !important;
                grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            }
        }
  
        @media (min-width: 992px) {
            #form-container-ref textarea { height: 117px !important; }
    
            #form-container-ref input:focus, 
            #form-container-ref textarea:focus,
            #form-container-ref div._formFieldContainer_1mxsl_5:has(label._inputFilled_1mxsl_74) input,
            #form-container-ref div._formFieldContainer_1mxsl_5:has(label._inputFilled_1mxsl_74) textarea { padding-bottom: 8px !important; }
    
            #form-container-ref input:focus + label,
            #form-container-ref textarea:focus ~ label,
            #form-container-ref input + label._inputFilled_1mxsl_74,
            #form-container-ref textarea ~ label._inputFilled_1mxsl_74 {
                top: 8px !important;
                left: 20px !important;
            }
    
            button._selectToggle_12thd_25 {
                font-size: 16px !important;
                min-height: 52px !important;
                max-height: 52px !important;
                padding: 18px 20px !important;
            }
    
            #app-embed ._inline_1q1d2_47 ._formBannerContainer_z5ku3_1 h2 { font-size: 46px; }
        }
    `;
  
    constructor() {
      this.container = null;
      this.isStyled = false;
      this.observer = null;
      this.timeoutId = null;
      this.styleEl = HeatPressInquiryForm.createStyleElement();
      this.start();
    }
  
    static createStyleElement() {
      const style = document.createElement('style');
      style.setAttribute(HeatPressInquiryForm.STYLE_ATTR, '');
      style.textContent = HeatPressInquiryForm.FORM_STYLES;
      return style;
    }
  
    static boot() {
      if (HeatPressInquiryForm.instance) return HeatPressInquiryForm.instance;
      HeatPressInquiryForm.instance = new HeatPressInquiryForm();
      return HeatPressInquiryForm.instance;
    }
  
    start() {
      this.bindForm();
      this.timeoutId = window.setTimeout(() => this.onTimeout(), HeatPressInquiryForm.TIMEOUT_MS);
    }
  
    bindForm() {
      const container = document.querySelector(HeatPressInquiryForm.SELECTOR);
      if (container) {
        this.attach(container);
        return;
      }
  
      this.observer = new MutationObserver(() => {
        const next = document.querySelector(HeatPressInquiryForm.SELECTOR);
        if (next) this.attach(next);
      });
  
      this.observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  
    attach(container) {
      this.container = container;
      container.setAttribute('aria-busy', 'true');
  
      if (this.enhance()) {
        this.cleanup();
        return;
      }
  
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => {
        if (this.enhance()) this.cleanup();
      });
      this.observer.observe(container, { childList: true, subtree: true });
    }
  
    enhance() {
      if (this.isStyled) return true;
  
      const shadow = this.container?.querySelector('#app-embed')?.shadowRoot;
      if (!shadow) return false;
  
      if (!shadow.querySelector(`style[${HeatPressInquiryForm.STYLE_ATTR}]`)) {
        shadow.prepend(this.styleEl);
      }
  
      this.reveal(true);
      return true;
    }
  
    reveal(styled) {
      if (!this.container) return;
  
      this.container.setAttribute('data-styled', 'true');
      this.container.removeAttribute('aria-busy');
      if (styled) this.isStyled = true;
    }
  
    onTimeout() {
      if (!this.isStyled) this.reveal(false);
      this.cleanup();
    }
  
    cleanup() {
      this.observer?.disconnect();
      this.observer = null;
  
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    }
  }
  
  HeatPressInquiryForm.boot();